module.exports = __webpack_public_path__ + "static/media/align-justify.d719a4f9.svg";